<div class="p-4 flex flex-col gap-4">
  <!-- Pull to Work in Process -->
  <div class="np-menu-card" (click)="goToPullBatches()">
    <div class="flex items-center gap-4">
      <i class="pi pi-shopping-cart np-menu-icon"></i>
      <div>
        <div class="text-xl font-semibold">Pull to Work in Process</div>
        <div class="text-sm opacity-70">Pull items from inventory into open batches</div>
      </div>
    </div>
    <i class="pi pi-chevron-right opacity-50 text-xl"></i>
  </div>

  <!-- Reserved #1 -->
  <div class="np-menu-card np-menu-disabled">
    <div class="flex items-center gap-4">
      <i class="pi pi-lock np-menu-icon"></i>
      <div>
        <div class="text-xl font-semibold">Reserved #1</div>
        <div class="text-sm opacity-50">Coming soon</div>
      </div>
    </div>
  </div>

  <!-- Reserved #2 -->
  <div class="np-menu-card np-menu-disabled">
    <div class="flex items-center gap-4">
      <i class="pi pi-lock np-menu-icon"></i>
      <div>
        <div class="text-xl font-semibold">Reserved #2</div>
        <div class="text-sm opacity-50">Coming soon</div>
      </div>
    </div>
  </div>
</div>
